module.exports = __webpack_public_path__ + "static/anfahrt-2c59109194dc1303f8ba502d8c7fb9f6.jpg";